<template>
  <div class="report-columns">
    <div class="report-columns-content">
      <button
        type="button"
        class="btn"
        title="Customizar colunas no do relatório"
        @click="show = !show"
      >
        <i class="fa fa-cog" aria-hidden="true"></i>
      </button>
      <div class="list" :style="{ display: show ? 'flex' : 'none' }">
        <label class="item">
          <input type="checkbox" @change="onChangeSelectAll" id="selectAll" />
          <span>Selecionar todos</span>
        </label>
        <label class="item" v-for="(item, index) of columns" :key="index" @change="onChangeCheckboxItem">
          <input type="checkbox" :name="`report_column[${item.key}]`" :disabled="item.mandatory" />
          <span>{{item.label}}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      required: true
    },
    allSelected: {
      required: false,
      default: true
    }
  },
  data: () => ({
    show: false
  }),
  watch: {
    show: function(val) {
      const content = document.getElementById("content");
      if (val) {
        setTimeout(() => {
          if (content.scrollHeight > content.clientHeight) {
            content.style.height = content.scrollHeight + 20 + "px";
          }
        }, 100);
      } else {
        content.removeAttribute("style");
      }
    }
  },
  methods: {
    onChangeSelectAll(ev) {
      if (ev.target.checked) {
        this.$el.querySelectorAll("input[type='checkbox']").forEach(node => {
          node.checked = true;
        });
      } else {
        this.$el.querySelectorAll("input[type='checkbox']").forEach(node => {
          if (!node.disabled) {
            node.checked = false;
          }
        });
      }
    },
    onChangeCheckboxItem(ev) { 
      if (!ev.target.checked) {
        this.$el.querySelector("#selectAll").checked = false;
      } else {
        const uncheckedChecksCount = Array.from(this.$el.querySelectorAll("input[type='checkbox']")).filter(node => {
          return (node.name.startsWith("report_column") && !node.checked)
        }).length;

        if (uncheckedChecksCount === 0) {
          this.$el.querySelector("#selectAll").checked = true;
        }
      }
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.show = false;
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.close);

    if (this.allSelected) {
      this.$el.querySelectorAll("input[type='checkbox']").forEach(node => {
        node.checked = true;
      });
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);
  }
};
</script>
<style lang="scss" scoped>
.report-columns {
  position: absolute;
  top: 0;
  right: 0;

  .report-columns-content {
    position: relative;

    .btn {
      font-size: 22px;
      padding: 0 5px;
      background: transparent !important;
      color: #828282;
      text-shadow: none;
      box-shadow: none;
      border: none !important;
      float: right;

      &:active {
        color: #535353;
      }
    }

    .list {
      background: #f1f1f1;
      border-radius: 3px;
      width: 255px;
      box-shadow: 0px 0px 3px #000;
      display: flex;
      flex-direction: column;
      position: absolute;
      right: 3px;
      top: 26px;
      max-height: 382px;
      overflow-y: auto;
      z-index: 9;

      .item {
        display: flex;
        align-items: center;
        padding: 5px;
        margin: 0;
        cursor: pointer;

        input[type="checkbox"] {
          margin: 4px;
        }

        span {
          font-size: 12px;
        }

        & + .item {
          border-top: 1px solid rgba(0, 0, 0, 0.125);
        }

        &:hover {
          background: #d2d2d2;
        }
      }
    }
  }
}
</style>
